import { graphql } from 'react-relay';

export const cutOffListFragment = graphql`
    fragment CutOffList_component on CutOffList {
        title
        introduction
        disclaimer
        cutOffTable {
            ...CutOffTable_table
        }
        salesAdmission {
            ...LabeledSelectBox_labeledSelectBox
        }
        downloadOverview {
            ...CutOffListDownload_cutOffListDownload
        }
    }
`;
